import { render } from "./PointManagement.vue?vue&type=template&id=1bf331e7"
import script from "./PointManagement.vue?vue&type=script&lang=js"
export * from "./PointManagement.vue?vue&type=script&lang=js"

import "./PointManagement.vue?vue&type=style&index=0&id=1bf331e7&lang=scss"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__